import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { getEvBranding, getEvLoan, recordEvPayment } from "../../../apis/evLoans";
import EvLoanRecord from "./EvLoanRecord";

const blankPayment = { amount: "", payment_date: "", payment_mode: "bank", reference: "" };
const requestError = (error) => error?.response?.data?.message || error?.message || "Request failed";

export default function EvLoanRecordPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loan, setLoan] = useState(null);
  const [brand, setBrand] = useState({});
  const [payment, setPayment] = useState(blankPayment);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState(location.state?.message || "");
  const backPath = location.state?.from || all_routes.evCustomerLoans;
  const userType = JSON.parse(sessionStorage.getItem("info") || "{}").type;

  const refresh = useCallback(async () => {
    const response = await getEvLoan(id);
    setLoan(response.data);
  }, [id]);

  useEffect(() => {
    setLoading(true);
    Promise.all([refresh(), getEvBranding().then((response) => setBrand(response.data || {})).catch(() => setBrand({}))])
      .catch((failure) => setError(requestError(failure))).finally(() => setLoading(false));
  }, [refresh]);

  async function submitPayment(event) {
    event.preventDefault();
    setBusy(true); setError(""); setMessage("");
    try {
      await recordEvPayment(id, payment);
      await refresh();
      setPayment(blankPayment);
      setMessage("EMI payment recorded");
    } catch (failure) { setError(requestError(failure)); }
    finally { setBusy(false); }
  }

  return <div className="page-wrapper modern-ui"><div className="content container-fluid">
    <Link className="btn btn-link ps-0 mb-2" to={backPath}><i className="ti ti-arrow-left me-1" /> Back to EV loans</Link>
    {loading && <p role="status">Loading EMI record...</p>}
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    {message && <div className="alert alert-success" role="status">{message}</div>}
    {!loading && loan?.status === "approved" && userType === "financer" &&
      <Link className="btn btn-primary" to={all_routes.evLoanDisbursement.replace(":id", id)}>Continue to disbursement</Link>}
    {!loading && loan && <EvLoanRecord loan={loan} brand={brand} initialSanction={new URLSearchParams(location.search).get("sanction") === "1"}
      onClose={() => navigate(backPath)}>
      {loan.status === "disbursed" && <form className="card shadow-sm mb-4" onSubmit={submitPayment}>
        <div className="card-header">Record EMI payment</div>
        <div className="card-body"><div className="row g-3">
          <div className="col-md-3"><label className="form-label" htmlFor="ev_payment_amount">Amount</label>
            <input id="ev_payment_amount" className="form-control" type="number" min="0.01" step="0.01" max={loan.outstanding_amount} required value={payment.amount}
              onChange={(event) => setPayment({ ...payment, amount: event.target.value })} /></div>
          <div className="col-md-3"><label className="form-label" htmlFor="ev_payment_date">Payment date</label>
            <input id="ev_payment_date" className="form-control" type="date" min={loan.disbursement_date || undefined} required value={payment.payment_date}
              onChange={(event) => setPayment({ ...payment, payment_date: event.target.value })} /></div>
          <div className="col-md-3"><label className="form-label" htmlFor="ev_payment_mode">Mode</label>
            <select id="ev_payment_mode" className="form-select" value={payment.payment_mode} onChange={(event) => setPayment({ ...payment, payment_mode: event.target.value })}>
              <option value="bank">Bank</option><option value="upi">UPI</option><option value="cash">Cash</option>
            </select></div>
          <div className="col-md-3"><label className="form-label" htmlFor="ev_payment_reference">Receipt or transaction reference</label>
            <input id="ev_payment_reference" className="form-control" required value={payment.reference}
              onChange={(event) => setPayment({ ...payment, reference: event.target.value })} /></div>
        </div><button className="btn btn-primary mt-3" disabled={busy}>Record payment</button></div>
      </form>}
    </EvLoanRecord>}
  </div></div>;
}
